// function snapTab(){
//     const tabs = gsap.utils.toArray('.tabs-navigation');

//     const tabTl = gsap.timeline({defaults: {ease: Power0.easeIn, duration: 0.5}});

//     tabTl.progress(0);

//     tabs.forEach((tabs) => {
        
//         tabTl.fromTo(tabs,
//             {y: `${$('header').height()}px`},
//             {y: 0},
//         ).progress(1)

//         ScrollTrigger.create(
//             {
//             trigger: $(tabs).closest('.tabs-sticky'),
//             pin: tabs,
//             pinSpacing: false,
//             end: "bottom top",
//             markers: false,
//             onUpdate: (self) => {
//                 if (self.direction === -1) {
//                     tabTl.reverse();
//                     $('.header__hovertail').removeClass('d-none');
//                 } else {
//                     tabTl.play();
//                     $('.header__hovertail').addClass('d-none');
//                 }
//             },
//             onEnter: ()=> tabTl.reverse(),
//             onLeave: ()=> { 
//                 tabTl.pause();
//                 $('.header__hovertail').removeClass('d-none');
//             },
//             onEnterBack: () => tabTl.resume(),
//             onLeaveBack: ()=> {
//                 tabTl.restart();
//                 $('.header__hovertail').removeClass('d-none');
//             },
//             scrub: false
//             }
//         );
//     })
// };

$('[data-bgscroll]').click(function(){
    $('[data-bgcontainer]').css('background-position-x',
     `${$(this).attr('data-bgscroll')}`);
})
